export default __webpack_public_path__ + "static/media/04-interactie.f52d9d55.png";